import { gql } from "@apollo/client";

export const GET_DELIVERY_REVOKE_REASON_I18N_CONFIG = gql`
    query GetDeliveryRevokeReasonI18nConfig {
        getDeliveryRevokeReasonI18nConfig {
            reasons {
                code
                zh
                en
                es
            }
        }
    }
`;

export interface DeliveryRevokeReasonI18nItemType {
    code: string;
    zh: string;
    en: string;
    es: string;
}

export interface GetDeliveryRevokeReasonI18nConfigResponse {
    getDeliveryRevokeReasonI18nConfig: {
        reasons: DeliveryRevokeReasonI18nItemType[];
    };
}
